import {z} from 'src/lib'
import {OperacionCorporateLendingDetalleFields, OperacionCorporateLendingFields} from "./fields";
import {schemaOperacionCorporateLending} from "./types";

export const schemaOperacionCorporateLendingDetalleInsert = z.object({
  [OperacionCorporateLendingDetalleFields.Deudor]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Acreedor]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Moneda]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Monto]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Destino]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.PlazoDisponibilidad]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Plazo]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Amortizacion]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Comision]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Precancelacion]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.TasaInteres]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FrecuenciaInteres]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FiadorAvalista]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Garantias]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Pagare]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Covenants]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Ley]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FechaEjecucion]: z.coerce.date().optional().nullable(),
});

export type OperacionCorporateLendingDetalleInsertDTO = z.infer<typeof schemaOperacionCorporateLendingDetalleInsert>;

export const schemaOperacionCorporateLendingInsert = z.object({
  [OperacionCorporateLendingFields.CodPais]: z.number(),
  [OperacionCorporateLendingFields.FechaVencimiento]: z.coerce.date(),
  [OperacionCorporateLendingFields.Envio]: z.boolean(),
  [OperacionCorporateLendingFields.Observaciones]: z.string().nullable().optional(),
  [OperacionCorporateLendingFields.Detalle]: schemaOperacionCorporateLendingDetalleInsert
})

export type OperacionCorporateLendingInsertDTO = z.infer<typeof schemaOperacionCorporateLendingInsert>;

export const schemaOperacionCorporateLendingView = schemaOperacionCorporateLending.omit({[OperacionCorporateLendingFields.Envio]: true})

export type OperacionCorporateLendingViewDTO = z.infer<typeof schemaOperacionCorporateLendingView>